import { connect } from 'react-redux';
import StoreFilterAgency from '.';
import { AppState } from '../../../redux/modules/store';
import { UserState } from '../../../redux/reducers/UserReducer';
import { FilterItem } from '../../../redux/reducers/StoreFilterReducer';
import { Dispatch } from 'redux';
import { storeFilterActions } from '../../../redux/modules/Actions';
import { getErrorMessageHeight } from './functions';
import { getClientErrorMsg, LIMIT_FILTER_ITEMS } from '../../../utils/CustomHooks/useValidateFilter';

interface AgencyUserInfo extends UserState {
  asmStaffDetailList?: { agencyCd: string; mainShopFlg: boolean }[];
  classCd?: string;
  postFlg?: string;
  postCd?: string;
  proxyloginowner?: string;
}

interface AgencyAppState extends AppState {
  loginUser: AgencyUserInfo;
}

const mapStateToProps = (appState: AgencyAppState) => {
  const filterStore = appState.filterStore;
  const { prohibitedWordMstList } = appState.masterInfo;
  const defaultFilter: FilterItem = {
    filterID: '',
    filterName: '',
    ordcstmCdList: [],
    isActive: true,
    checked: false,
    sortOrder: 0,
    isExist: true,
  };
  const active = filterStore.data.findIndex((item) => item.isActive === true);
  const itemActive: FilterItem = active !== -1 ? filterStore.data[active] : defaultFilter;
  const isLimitFilterItem = LIMIT_FILTER_ITEMS === filterStore.cloneData.length && 'filterUuid' in itemActive;
  const clientErrorMsg = getClientErrorMsg({
    itemActive,
    cloneData: filterStore.cloneData,
    prohibitedWordMstList,
    isLimitFilterItem,
  });

  return {
    postCd: appState.loginUser.postCd || '',
    stores: appState.loginUser.stores || [],
    targetStores: itemActive.ordcstmCdList || [],
    itemActive,
    errorMessageHeight: getErrorMessageHeight(!!clientErrorMsg, !!itemActive.isExist, filterStore.msg.length),
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateDraftStore: (itemActive: FilterItem) => {
      dispatch(storeFilterActions.draftFilter.update(itemActive));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreFilterAgency);
